<template>
  <div class="topDiv">
    <label v-if="!noLabel" class="teams-label-font"
      >{{ label }}<span v-if="mandatory" class="asterik">*</span></label
    >
    <div class="select-div topDiv">
      <div
        ref="landingdrop"
        class="customised-form-tags"
        :class="{
          bindingClass: disabled,
          showErrorClass: showError,
          'expandable-tags': id == 'skills',
        }"
      >
        <b-form-tags
          :style="id && id == 'kanbanskills' && 'height : 36px !important;'"
          ref="tags"
          :id="id"
          :type="type"
          no-outer-focus
          remove-on-delete
          v-model="inputData"
          :disabled="disabled"
          @input="handleInput"
          @blur="$emit('handle-blur')"
          tabindex="0"
          :tag-validator="tagValidator"
          :invalid-tag-text="lengthError ? null : 'Duplicate tag(s)'"
          separator=",;"
          :placeholder="disabled ? '' : placeholder"
        >
        </b-form-tags>
        <img
          v-if="id == 'skills' && !disabled"
          class="expand-tags-icon pointer"
          src="../../assets/new-kanban-icons/expand-icon.svg"
          alt=""
          @click.stop="openExpandModal()"
        />
      </div>
      <div
        v-closable="{
          exclude: ['landingdrop'],
          handler: 'hideLandingDropdown',
        }"
        @scroll="onScroll"
        v-if="openDropdown && !expandModalOpen && dropDownOptions.length != 0"
        class="selectCustom-dropdown pointer"
      >
        <div
          class="selectCustom-dropdown-innerContent"
          v-for="(opt, index) in dropDownOptions"
          :key="index"
          :id="opt.value"
          @click.stop="selectOption(opt)"
          :class="{
            'selectCustom-opt-selected': inputData.includes(opt.value),
            'selectCustom-opt-unselected': !inputData.includes(opt.value),
          }"
          :tabindex="index === 0 ? 0 : -1"
        >
          {{ opt.text }}
        </div>
        <div
          style="margin: auto"
          v-if="showSpinner"
          class="d-flex justify-content-center mt-2"
        >
          <b-spinner label="Loading..."></b-spinner>
        </div>
      </div>
      <div class="newInt-required-validation-font mt-1" v-if="lengthError">
        Exceeded max char length
      </div>
    </div>
    <b-modal
      v-if="id == 'skills'"
      :id="expandModalId"
      size="lg"
      centered
      hide-footer
      hide-header
      @shown="$refs.modalInput.focus()"
      @hidden="closeExpandModal()"
    >
      <div>
        <div class="cs-modal-header">
          <div>
            {{ label || "Skills" }}
            <span class="expand-tags-count">{{ modalTags.length }}</span>
          </div>
          <div @click="$bvModal.hide(expandModalId)">
            <img
              class="rotate-on-hover pointer"
              src="../../assets/img/accessconnew/blueCross.svg"
              alt=""
            />
          </div>
        </div>
        <div class="expand-tags-body">
          <div class="position-relative">
            <b-form-input
              ref="modalInput"
              v-model="modalNewTag"
              class="expand-tags-input"
              :placeholder="placeholder"
              autocomplete="off"
              @input="onModalInput"
              @keydown="onModalKeydown"
            ></b-form-input>
            <div
              v-closable="{
                exclude: ['modalInput'],
                handler: 'hideLandingDropdown',
              }"
              @scroll="onScroll"
              v-if="
                openDropdown && expandModalOpen && dropDownOptions.length != 0
              "
              class="selectCustom-dropdown expand-tags-dropdown pointer"
            >
              <div
                class="selectCustom-dropdown-innerContent"
                v-for="(opt, index) in dropDownOptions"
                :key="index"
                @click.stop="selectModalOption(opt)"
                :class="{
                  'selectCustom-opt-selected': modalTags.includes(opt.value),
                  'selectCustom-opt-unselected': !modalTags.includes(opt.value),
                }"
              >
                {{ opt.text }}
              </div>
              <div
                style="margin: auto"
                v-if="showSpinner"
                class="d-flex justify-content-center mt-2"
              >
                <b-spinner label="Loading..."></b-spinner>
              </div>
            </div>
          </div>
          <div class="expand-tags-hint mt-1">
            <span class="newInt-required-validation-font" v-if="modalError">
              {{ modalError }}
            </span>
            <span class="cf-light-txt-2" v-else>
              Press "Enter" to add skills
            </span>
          </div>
          <div ref="modalTagsList" class="expand-tags-list">
            <span
              class="expand-tag"
              v-for="(tag, index) in modalTags"
              :key="tag"
            >
              {{ tag }}
              <span
                class="expand-tag-remove pointer"
                @click="modalTags.splice(index, 1)"
                >&times;</span
              >
            </span>
            <div v-if="!modalTags.length" class="cf-light-txt-2">
              No skills added yet
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { getSkillSuggestion } from "../../utils/apiFunctions";

export default {
  name: "FormTags",
  props: {
    bindingClass: String,
    disabled: Boolean,
    noLabel: Boolean,
    type: String,
    label: String,
    mandatory: Boolean,
    placeholder: String,
    id: String,
    showError: Boolean,
    maxLength: Number,
    vmodel: {
      validator: function () {
        return true;
      },
    },
  },
  computed: {
    // Unique per instance, so two skills boxes on one screen never share a modal
    expandModalId() {
      return `expand-tags-${this._uid}`;
    },
  },
  created() {
    if (this.vmodel) {
      this.inputData = this.vmodel;
    }
    if (this.id == "skills")
      this.debouncedSkillSearch = this.debounce(this.fetchSkills, 400);
  },
  watch: {
    vmodel(newVal) {
      this.inputData = newVal;
    },
    // Every add/remove in the modal reaches the form right away
    modalTags() {
      if (this.expandModalOpen) this.syncModalTags();
    },
  },
  data() {
    return {
      inputData: [],
      lengthError: false,
      openDropdown: false,
      skipNextValidation: false,
      showSpinner: false,
      pageEnd: null,
      total: null,
      page: 0,
      searchQuery: "",
      dropDownOptions: [],
      debouncedSkillSearch: null,
      modalTags: [],
      modalNewTag: "",
      modalError: "",
      expandModalOpen: false,
    };
  },
  methods: {
    async fetchSkills(tag) {
      this.searchQuery = tag;
      this.page = 0;
      await this.getSkillSuggestion();
      // While the modal is open, suggestions belong to its input and only show
      // if they still match what is typed there (a late response is dropped).
      if (this.expandModalOpen)
        this.openDropdown = this.modalNewTag.trim() == tag;
      else if (!this.skipNextValidation) this.openDropdown = true;
    },
    checkbetween(x, min, max) {
      return x > min && x < max;
    },
    onScroll(e) {
      const { target } = e;
      if (
        Math.ceil(target.scrollTop) >=
        target.scrollHeight - target.offsetHeight
      ) {
        if (
          this.checkbetween(this.pageEnd, 0, this.total) &&
          !this.showSpinner
        ) {
          this.showSpinner = true;
          this.page++;
          this.getSkillSuggestion();
        }
      }
    },
    async getSkillSuggestion() {
      try {
        let payload = {
          page: this.page,
          search: this.searchQuery,
        };
        const res = await getSkillSuggestion(payload);
        if (res.status == 200) {
          if (this.page == 0) {
            this.dropDownOptions = res.data.data.response;
          } else {
            this.dropDownOptions = [
              ...this.dropDownOptions,
              ...res.data.data.response,
            ];
          }
          this.pageEnd = res.data.data.end_page;
          this.total = res.data.data.total_count;
          this.showSpinner = false;
        }
      } catch (error) {
        console.error(error);
      }
    },
    handleInput() {
      if (this.id == "skills") {
        this.openDropdown = false;
        this.skipNextValidation = true;
      }
      this.$emit("select-value", this.inputData);
      this.$emit("handle-input");
      this.$nextTick(() => {
        const tagsContainer =
          this.$refs.tags.$el.querySelector(".b-form-tags-list");

        if (tagsContainer) {
          tagsContainer.scrollLeft =
            tagsContainer.scrollWidth - tagsContainer.clientWidth;
        } else {
          console.error("Tags container not found via ref");
        }
        if (this.id == "skills") {
          const tagInput = this.$refs.tags?.$el?.querySelector("input");
          if (tagInput) {
            tagInput.value = "";
            tagInput.dispatchEvent(new Event("input"));
            this.searchQuery = "";
            this.openDropdown = false;
          }
        }
      });
    },
    debounce(fn, delay) {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => fn.apply(this, args), delay);
      };
    },
    selectOption(value) {
      this.skipNextValidation = true;
      let ind = this.inputData.indexOf(value.text);
      if (ind != -1) {
        this.inputData.splice(ind, 1);
      } else this.inputData.push(value.text);
      this.handleInput();
      this.$nextTick(() => {
        const tagInput = this.$refs.tags?.$el?.querySelector("input");
        if (tagInput) {
          tagInput.value = "";
          tagInput.dispatchEvent(new Event("input"));
          this.searchQuery = "";
          this.openDropdown = false;
        }
      });
    },
    hideLandingDropdown() {
      this.openDropdown = false;
    },
    tagValidator(tag) {
      if (this.id == "skills") {
        // Skip one suggestion search after a tag is added so the dropdown
        // doesn't reopen. Don't return false here: b-form-tags reports any
        // `false` as "Duplicate tag(s)".
        if (this.skipNextValidation) {
          this.skipNextValidation = false;
        } else if (tag.length >= 2) {
          this.debouncedSkillSearch(tag);
        } else this.openDropdown = false;
      }
      if (tag.length > this.maxLength) {
        this.$emit("length-error", true);
        this.lengthError = true;
        return false;
      } else {
        this.$emit("length-error", false);
        this.lengthError = false;
      }
      let data = this.inputData.map((s) => s.toLowerCase());
      return !data.includes(tag.toLowerCase());
    },
    openExpandModal() {
      this.modalTags = [...(this.inputData || [])];
      this.modalNewTag = "";
      this.modalError = "";
      this.openDropdown = false;
      this.expandModalOpen = true;
      this.$bvModal.show(this.expandModalId);
    },
    syncModalTags() {
      if (this.modalTags.join() == (this.inputData || []).join()) return;
      this.inputData = [...this.modalTags];
      this.$emit("select-value", this.inputData);
      this.$emit("handle-input");
    },
    // Every way of closing (icon, backdrop, Esc) lands here; a skill still
    // typed in the input is added before closing.
    closeExpandModal() {
      this.expandModalOpen = false;
      this.openDropdown = false;
      this.addModalTag();
      this.syncModalTags();
    },
    // Checked as you type (like the outer box), so Enter never has to show it
    modalTagError(tag) {
      if (!tag) return "";
      if (tag.length > this.maxLength) return "Exceeded max char length";
      const data = this.modalTags.map((s) => s.toLowerCase());
      if (data.includes(tag.toLowerCase())) return `Duplicate skill: ${tag}`;
      return "";
    },
    onModalInput(value) {
      this.modalError = this.modalTagError(value.trim());
      if (value.trim().length >= 2) this.debouncedSkillSearch(value.trim());
      else this.openDropdown = false;
    },
    selectModalOption(value) {
      let ind = this.modalTags.indexOf(value.text);
      if (ind != -1) {
        this.modalTags.splice(ind, 1);
      } else this.modalTags.push(value.text);
      this.modalNewTag = "";
      this.modalError = "";
      this.openDropdown = false;
      this.$refs.modalInput.focus();
    },
    onModalKeydown(event) {
      if (["Enter", ",", ";"].includes(event.key)) {
        event.preventDefault();
        this.addModalTag();
      }
    },
    addModalTag() {
      const tag = this.modalNewTag.trim();
      if (!tag || this.modalTagError(tag)) return;
      this.modalTags.push(tag);
      this.modalNewTag = "";
      this.modalError = "";
      this.openDropdown = false;
      this.$nextTick(() => {
        const list = this.$refs.modalTagsList;
        if (list) list.scrollTop = list.scrollHeight;
      });
    },
  },
};
</script>

<style scoped>
.showErrorClass .form-control {
  border: 1px solid red !important;
}
.expandable-tags {
  position: relative;
}
.expand-tags-icon {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
}
.expand-tags-count {
  margin-left: 6px;
  padding: 1px 10px;
  border-radius: 12px;
  background-color: #f1f7ff;
  color: #20639b;
  font-family: "Montserrat", sans-serif;
  font-size: 13px;
  font-weight: 500;
}
/* Input on top, tags below: the tag list starts at 4 rows and grows with the
   modal up to 480px, after which the list scrolls. */
.expand-tags-body {
  display: flex;
  flex-direction: column;
  max-height: min(480px, 75vh);
  padding: 20px 25px 24px;
}
.expand-tags-list {
  flex: 0 1 auto;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  gap: 8px;
  min-height: 128px; /* 4 rows of 26px tags + 3 gaps */
  overflow-y: auto;
  margin-top: 12px;
}
/* Fixed height so switching between the hint and an error never moves the list */
.expand-tags-hint {
  height: 18px;
  line-height: 18px;
  font-size: 12px;
  overflow: hidden;
}
.expand-tags-hint span {
  display: block;
  margin: 0;
  line-height: 18px;
}
.expand-tags-dropdown {
  top: 100%;
  margin-top: 4px;
  z-index: 2;
}
.expand-tag {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  padding: 4px 10px;
  border-radius: 15px;
  background-color: #f1f7ff;
  color: #20639b;
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  word-break: break-word;
}
.expand-tag-remove {
  margin-left: 6px;
  font-size: 15px;
  line-height: 1;
}
.expand-tags-input {
  height: 36px;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  color: #333333;
}
</style>
<style>
.customised-form-tags .b-form-tags-list::-webkit-scrollbar {
  height: 3px !important;
}
.customised-form-tags .b-form-tags .b-form-tags-list .b-from-tags-field,
.b-form-tags .b-form-tags-list .b-form-tag {
  margin-top: 0 !important;
}
.customised-form-tags.expandable-tags .form-control {
  padding-right: 36px;
}
</style>
